import { gql } from '@/features/graphql/generated'

export const ProductItemFragment = gql(/* GraphQL */ `
    fragment ProductItem on Product {
        uuid
        name
        priceInfo {
            price {
                amount
                currency
            }
        }
        soldOut
        productVariants {
            uuid
        }
        label {
            name
            color
        }
    }
`)
